export const USER_COLUMN_ID = {
  email: 'email',
  fullName: 'user_name',
  role: 'role',
  status: 'status',
  labels: 'labels',
} as const;

export type ColumnOption = { label: string; value: string | number };

export type UserColumnConfig = {
  id: string;
  label: string;
  type: string;
  isHidden: boolean;
  isMandatory: boolean;
  options: ColumnOption[] | null;
};

export const userColumnsFallback: UserColumnConfig[] = [
  {
    id: 'user_name',
    label: 'User Name',
    type: 'text',
    isHidden: false,
    isMandatory: true,
    options: null,
  },
  {
    id: 'role',
    label: 'Role',
    type: 'select',
    isHidden: false,
    isMandatory: false,
    options: [
      { label: 'Admin', value: 'Admin' },
      { label: 'Campaign Manager', value: 'Campaign Manager' },
      { label: 'Digital Strategist', value: 'Digital Strategist' },
      { label: 'Owner', value: 'Owner' },
      { label: 'Planner', value: 'Planner' },
      { label: 'Viewer', value: 'Viewer' },
    ],
  },
  {
    id: 'status',
    label: 'Status',
    type: 'text',
    isHidden: false,
    isMandatory: false,
    options: null,
  },
  {
    id: 'labels',
    label: 'Labels',
    type: 'text',
    isHidden: false,
    isMandatory: false,
    options: null,
  },
  {
    id: 'email',
    label: 'Email',
    type: 'text',
    isHidden: false,
    isMandatory: true,
    options: null,
  },
];
